import { render, staticRenderFns } from "./ExprCall.vue?vue&type=template&id=24adecdb&scoped=true&"
import script from "./ExprCall.vue?vue&type=script&lang=ts&"
export * from "./ExprCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24adecdb",
  null
  
)

export default component.exports